import type { AppContext } from 'types/common'
import type { BaseAttachmentFile } from '@isoftdata/svelte-attachments'

import component from './Attachment.svelte'
import { v4 as uuid } from '@lukeed/uuid'
import { graphql } from '$houdini'

export default function ({ mediator, stateRouter, i18next: { t: translate } }: AppContext) {
	stateRouter.addState({
		name: 'app.vehicle.attachment',
		route: 'attachment',
		querystringParameters: ['vehicleId', 'storeId'],
		template: {
			svelte: true,
			component,
		},
		// canLeaveState(domApi) {
		//     // @ts-expect-error it's fine
		//     // eslint-disable-next-line @typescript-eslint/no-unsafe-call
		//     return domApi.canLeaveState() as boolean
		// },
		async resolve(_data, parameters) {
			const vehicleId = parseInt(parameters.vehicleId, 10)
			const storeId = parseInt(parameters.storeId, 10)

			const { data } = await vehicleAttachmentsQuery.fetch({
				variables: {
					vehicleId,
				},
			})

			if (!data) {
				throw new Error(
					translate('vehicle.failedToLoadVehicleAttachmentsData', 'Failed to load vehicle attachments data'),
				)
			}

			const fileList: Array<BaseAttachmentFile & { vehicleId: number }> =
				data.vehicle?.attachments.map(attachment => {
					return {
						...attachment.file,
						vehicleId,
						fileId: attachment.fileId,
						uuid: uuid(),
						public: attachment.public,
						rank: attachment.rank,
						createdDate: attachment.file.createdDate.toISOString(),
					}
				}) ?? []

			return {
				storeId,
				vehicleId,
				fileList,
			}
		},
	})
}

const vehicleAttachmentsQuery = graphql(`
	query VehicleAttachments($vehicleId: Int!) {
		vehicle(id: $vehicleId) {
			attachments {
				fileId: id
				rank
				public
				file {
					id
					name
					path: url
					type
					size
					mimeType: mimetype
					extension
					updated
					createdDate: created
				}
			}
		}
	}
`)
